(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayoyo-hero-rose"] && !Shopify.designMode) return;
  try {
    
  class AyoyoRoseJourney {
    constructor(root) {
      this.root = root;
      this.stage = root.querySelector('.rj__stage');
      this.world = root.querySelector('.rj__world');
      this.muse = root.querySelector('.rj__muse');
      this.open = root.querySelector('.rj__copy--open');
      this.arrival = root.querySelector('.rj__copy--arrival');
      this.chapter = root.querySelector('.rj__chapter');
      this.loading = root.querySelector('.rj__loading');
      this.playBtn = root.querySelector('.rj__play');
      this.seek = root.querySelector('.rj__seek');
      this.timeEl = root.querySelector('.rj__time');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.immersive = root.dataset.immersive === 'true';
      this.autoplay = root.dataset.autoplay === 'true' && !this.reduced;
      const total = (parseFloat(root.dataset.duration) || 19) * 1000;
      this.hold = 1000;
      this.duration = Math.max(1000, total - this.hold);
      this.chapters = JSON.parse(root.dataset.chapters || '[]');
      this.init();
    }

    static clamp(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    static smooth(a, b, x) { const t = AyoyoRoseJourney.clamp((x - a) / (b - a)); return t * t * (3 - 2 * t); }

    buildLayers() {
      // Perspective-projected transparent botanical planes - not a 3D mesh.
      const specs = [
        [-620,-190,950,700,30,1],[650,220,1150,820,-145,0],[-530,410,1250,850,-30,0],
        [720,-300,1800,840,155,1],[-710,-380,1900,820,25,0],[650,440,2050,860,-120,0],
        [-780,120,2450,960,-20,1],[820,-140,2650,950,140,0],[-620,-560,2770,800,45,0],
        [650,650,2900,920,-140,1],[-850,660,3100,980,-45,0],
        [-1100,-600,3850,1120,35,1],[1100,-500,3950,1100,160,0],
        [-1150,560,4000,1300,-20,0],[1120,620,4200,1240,-140,1],
        [-1400,-40,4500,1150,5,0],[1400,80,4600,1250,175,0]
      ];
      const src = this.root.dataset.branch;
      if (!src) return [];
      return specs.map((s, i) => {
        const img = new Image();
        img.src = src; img.className = 'rj__branch'; img.alt = ''; img.decoding = 'async';
        this.world.append(img);
        return { img, x: s[0], y: s[1], z: s[2], size: s[3], rot: s[4], flip: s[5], i };
      });
    }

    render(time = 0) {
      const S = AyoyoRoseJourney.smooth, C = AyoyoRoseJourney.clamp, p = this.p;
      const w = this.width, h = this.height;
      const mobile = w < 700, unit = mobile ? w / 650 : Math.min(w / 1440, h / 900);
      const camera = 2200 * S(0, 1, p), f = 900;

      for (const l of this.layers) {
        const depth = l.z - camera;
        if (depth < 130) { l.img.style.visibility = 'hidden'; continue; }
        l.img.style.visibility = 'visible';
        const scale = f / depth;
        const openingSpace = l.x < 0 ? 420 * (1 - S(0.12, 0.45, p)) : 0;
        const x = ((l.x - openingSpace) * (mobile ? 0.69 : 1) - this.mouse.x * 16) * scale * unit;
        const y = (l.y - this.mouse.y * 8) * scale * unit;
        const drift = this.reduced ? 0 : Math.sin(time * 0.0003 + l.i) * 1.5;
        l.img.style.width = l.size * unit + 'px';
        l.img.style.transform = `translate(-50%,-50%) translate3d(${x}px,${y}px,0) scale(${scale * (l.flip ? -1 : 1)},${scale}) rotate(${l.rot + drift}deg)`;
        l.img.style.opacity = C((depth - 130) / 180) * (0.64 + 0.36 * C(1800 / depth));
        l.img.style.zIndex = String(Math.round(100000 / depth));
        const blur = depth < 650 ? Math.min(5, (650 - depth) / 100) : depth > 3300 ? 1.5 : 0;
        l.img.style.filter = blur ? `blur(${blur}px)` : 'none';
      }

      if (this.muse) {
        const d = 1350 - camera, ms = f / Math.max(d, 200);
        this.muse.style.width = (mobile ? 740 : 900) * unit + 'px';
        this.muse.style.transform = `translate(-50%,-50%) translate3d(${(mobile ? 185 : 340) * ms * unit}px,${(mobile ? -400 : 30) * ms * unit}px,0) scale(${ms})`;
        this.muse.style.opacity = 1 - S(0.37, 0.56, p);
        this.muse.style.visibility = p > 0.57 ? 'hidden' : 'visible';
        this.muse.style.zIndex = String(Math.round(100000 / Math.max(200, d)));
      }

      const opening = 1 - S(0.09, 0.27, p), arrival = S(0.64, 0.88, p);
      if (this.open) {
        this.open.style.opacity = opening;
        this.open.style.transform = `translateY(${-12 * (1 - opening)}px)`;
        this.open.style.pointerEvents = opening > 0.5 ? 'auto' : 'none';
        this.open.inert = opening < 0.5;
        this.open.setAttribute('aria-hidden', String(opening < 0.01));
      }
      if (this.arrival) {
        this.arrival.style.opacity = arrival;
        this.arrival.style.transform = `translateY(${15 * (1 - arrival)}px)`;
        this.arrival.style.pointerEvents = arrival > 0.5 ? 'auto' : 'none';
        this.arrival.inert = arrival < 0.5;
        this.arrival.setAttribute('aria-hidden', String(arrival < 0.01));
      }
      if (this.seek) this.seek.value = String(Math.round(p * 1000));
      if (this.timeEl) this.timeEl.textContent = '00:' + String(Math.round(p * this.duration / 1000)).padStart(2, '0');
      if (this.chapter && this.chapters.length === 3) {
        this.chapter.textContent = p < 0.3 ? this.chapters[0] : p < 0.68 ? this.chapters[1] : this.chapters[2];
      }
    }

    syncButton() {
      if (!this.playBtn) return;
      this.playBtn.textContent = this.playing ? 'Pause' : this.p >= 0.999 ? 'Watch again' : 'Play';
      this.playBtn.setAttribute('aria-label', this.playing ? 'Pause animation' : 'Play animation');
    }

    // A deliberate stop (the Pause button, the seek bar, Skip) sticks.
    hardPause() { this.userPaused = true; this.playing = false; this.target = this.p; this.syncButton(); }
    // A transient one (a scroll nudge, a tab switch) must hand playback back.
    softPause() { this.playing = false; this.target = this.p; this.syncButton(); }
    resume() {
      if (this.userPaused || !this.ready || this.p >= 0.999) return;
      this.elapsed = this.p * this.duration + this.hold;
      this.playing = true;
      this.syncButton();
    }

    takeChrome() {
      if (!this.immersive || this.reduced || !this.autoplay) return;
      const chrome = [...document.querySelectorAll('.shopify-section-group-header-group')];
      if (!chrome.length) return;
      const chromeH = chrome.reduce((t, el) => t + el.getBoundingClientRect().height, 0);
      if (this.root.getBoundingClientRect().top > chromeH + 8) return;
      this.chrome = chrome;
      chrome.forEach((el) => {
        el.style.height = el.getBoundingClientRect().height + 'px';
        el.classList.add('rj-chrome');
      });
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!this.chromeReleased) document.documentElement.classList.add('rj-immersive');
      }));
      this.release = this.releaseChrome.bind(this);
      ['wheel', 'touchstart', 'keydown', 'pointerdown', 'resize'].forEach((t) =>
        window.addEventListener(t, this.release, { passive: true }));
    }

    releaseChrome() {
      if (this.chromeReleased || !this.chrome) return;
      this.chromeReleased = true;
      document.documentElement.classList.remove('rj-immersive');
      ['wheel', 'touchstart', 'keydown', 'pointerdown', 'resize'].forEach((t) =>
        window.removeEventListener(t, this.release));
      setTimeout(() => {
        this.chrome.forEach((el) => { el.style.height = ''; el.classList.remove('rj-chrome'); });
      }, 520);
    }

    tick(now) {
      const dt = Math.min(60, now - this.last || 16);
      this.last = now;
      this.mouse.x += (this.pointer.x - this.mouse.x) * 0.04;
      this.mouse.y += (this.pointer.y - this.mouse.y) * 0.04;
      if (this.playing) {
        this.elapsed += dt;
        this.target = AyoyoRoseJourney.clamp(Math.max(0, this.elapsed - this.hold) / this.duration);
        this.p = this.target;
        if (this.p >= 1) { this.playing = false; this.syncButton(); this.releaseChrome(); }
      } else {
        this.p += (this.target - this.p) * (1 - Math.exp(-dt / 120));
      }
      this.render(now);
      if (this.visible) this.raf = requestAnimationFrame(this.tick);
    }

    scrub(delta) {
      this.softPause();
      this.target = AyoyoRoseJourney.clamp(this.target + delta / 1400);
      this.releaseChrome();
      clearTimeout(this.resumeTimer);
      this.resumeTimer = setTimeout(() => this.resume(), 1100);
    }

    measure() { this.width = this.stage.clientWidth; this.height = this.stage.clientHeight; }

    init() {
      this.p = 0; this.target = 0; this.playing = false; this.ready = false;
      this.userPaused = false; this.elapsed = 0; this.last = 0; this.visible = true;
      this.raf = 0; this.resumeTimer = 0; this.wasPlaying = false;
      this.mouse = { x: 0, y: 0 }; this.pointer = { x: 0, y: 0 };
      this.layers = this.buildLayers();
      this.measure();
      this.tick = this.tick.bind(this);
      this.render(0);

      // Horizon scrolls an inner .page-wrapper, so window scroll position is useless
      // here. Drive manual scrubbing from wheel/touch deltas instead.
      // Scroll capture must RELEASE, and `p` never reaches exactly 1.
      //
      // `p` eases toward `target` asymptotically, so after the sequence finishes
      // it sits at something like 0.9996 -- forever less than 1. The old guard
      // (`this.p < 1`) therefore swallowed every downward wheel for the rest of
      // the page's life: the animation looked finished (the seek readout rounds
      // p*1000 to "1000") but the visitor could not scroll past the hero at all.
      // Continuous wheeling made it worse, because each scrub cleared the resume
      // timer so playback never completed either.
      //
      // EPS is the tolerance that decides "done enough to hand scrolling back".
      const EPS = 0.004;
      const atEnd = () => this.p >= 1 - EPS;
      const atStart = () => this.p <= EPS;

      this.root.addEventListener('wheel', (e) => {
        // Someone who asked for reduced motion must never have their scroll
        // captured for an animation they opted out of.
        if (this.reduced) return;
        if (e.deltaY > 0 && !atEnd()) { e.preventDefault(); this.scrub(e.deltaY); }
        else if (e.deltaY < 0 && !atStart() && this.stage.getBoundingClientRect().top >= 0) {
          e.preventDefault(); this.scrub(e.deltaY);
        }
      }, { passive: false });
      let ty = 0;
      this.root.addEventListener('touchstart', (e) => { ty = e.touches[0].clientY; }, { passive: true });
      this.root.addEventListener('touchmove', (e) => {
        if (this.reduced) return;
        const d = ty - e.touches[0].clientY; ty = e.touches[0].clientY;
        if ((d > 0 && !atEnd()) || (d < 0 && !atStart())) { e.preventDefault(); this.scrub(d * 2.2); }
      }, { passive: false });

      if (this.playBtn) this.playBtn.onclick = () => {
        if (!this.ready) return;
        if (this.playing) this.hardPause();
        else { this.userPaused = false; if (this.p > 0.999) this.p = 0; this.resume(); }
      };
      const replay = this.root.querySelector('.rj__replay');
      if (replay) replay.onclick = () => {
        if (!this.ready) return;
        this.userPaused = false; this.p = this.target = 0; this.elapsed = 0;
        this.playing = !this.reduced; this.syncButton(); this.render(0);
      };
      const skip = this.root.querySelector('.rj__skip');
      if (skip) skip.onclick = () => { this.hardPause(); this.target = 1; this.releaseChrome(); if (this.reduced) { this.p = 1; this.render(0); } };
      if (this.seek) this.seek.oninput = (e) => {
        this.hardPause(); this.p = this.target = Number(e.target.value) / 1000;
        this.releaseChrome(); this.syncButton(); this.render(0);
      };

      addEventListener('resize', () => { this.measure(); this.render(0); });
      this.stage.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'mouse' && !this.reduced) {
          this.pointer.x = e.clientX / this.width - 0.5;
          this.pointer.y = e.clientY / this.height - 0.5;
        }
      });
      this.stage.addEventListener('pointerleave', () => { this.pointer.x = this.pointer.y = 0; });
      document.addEventListener('visibilitychange', () => {
        this.visible = !document.hidden;
        if (!this.visible) { this.wasPlaying = this.playing; cancelAnimationFrame(this.raf); this.softPause(); }
        else { this.last = performance.now(); this.raf = requestAnimationFrame(this.tick); if (this.wasPlaying) this.resume(); }
      });

      // Start on decode, but never let a slow image hold the hero hostage.
      const imgs = [this.muse, ...this.layers.map((l) => l.img)].filter(Boolean);
      const decoded = Promise.all(imgs.map((im) => (im.decode ? im.decode().catch(() => {}) : null)));
      const capped = new Promise((r) => setTimeout(r, 3000));
      Promise.race([decoded, capped]).then(() => {
        this.measure();
        this.ready = true;
        if (this.loading) {
          this.loading.style.opacity = 0;
          this.loading.style.pointerEvents = 'none';
          setTimeout(() => { this.loading.hidden = true; }, 650);
        }
        if (this.autoplay) { this.takeChrome(); this.elapsed = 0; this.playing = true; }
        this.syncButton();
        this.last = performance.now();
        this.raf = requestAnimationFrame(this.tick);
      });
    }
  }

  document.querySelectorAll('.rj').forEach((el) => {
    if (!el.dataset.rjInit) { el.dataset.rjInit = '1'; new AyoyoRoseJourney(el); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
